import { Pagination } from '@th-types/pageable.type';
import { JobAssignment } from '@th-types/job.detail.type';

/**
 * Types for the JobOverview / DetailV2 component tree
 */

// need to think better name for this type, or ask BE to normalize the worker object
// in responses to render the CandidateCard component.
export interface JobCandidateDTO {
  id: number;
  firstName: string;
  lastName: string;
  fullName: string;
  profileImageUrl?: string;
  rating: number;
  isPremium: boolean;
  personalVideoId?: number;
  distance?: number;
  // Only present when this DTO is returned directly (e.g. considered-workers).
  isNewApplicant?: boolean;
  // Only present on considered-workers response
  hasApplied?: boolean;
  matchSkills?: boolean;
  jobAssignmentId?: number;
}

export interface SuggestedWorkerResult {
  worker: JobCandidateDTO;
  jobAssignment?: JobAssignment;
  jobAssignmentId?: number;
  distance: number;
  matchSkills?: boolean;
  isFavoritedByCompany: boolean;
  isBlockedByCompany: boolean;
  isConsidered?: boolean;
}

export interface ISuggestedWorkersData {
  pagination: Pagination;
  results: SuggestedWorkerResult[];
  restrictedAccess?: boolean;
}

export interface IConsideredWorkersData {
  pagination: Pagination;
  results: JobCandidateDTO[];
}

// ── UI view-models ─────────────────────────────────────────────────────────

/** Enum for candidate panel tabs */
export enum CandidateStage {
  NEW = 'new',
  APPLICANTS = 'applicants',
  CONSIDERING = 'considering',
  SUGGESTED = 'suggested',
  HIDDEN = 'hidden',
  OFFERED = 'offered',
  HIRED = 'hired',
}

export interface CandidateTag {
  label: string;
  variant: string; // Badge variant configured in statusColors.ts (e.g. 'tagNew').
}

export interface NormalizedCandidateShape {
  id: number;
  name: string;
  avatarUrl?: string;
  miles?: number;
  rating: number;
  inNetwork?: boolean;
  favorite?: boolean;
  tags: CandidateTag[];
  jobAssignmentId?: number;
  hidden?: boolean;
  considered?: boolean;
}
